import { Injectable } from '@angular/core';
import { firstValueFrom, take } from 'rxjs';
import { EfCakeTopologyUiState } from 'src/app/shared/models/ef-cake-topology.model';
import { EfateCakeTopologyApiService } from 'src/app/shared/services/efate-cake/efate-cake-topology.api.service';
import { EfCakeTopologyStateUtils } from '../utils/ef-cake-topology-state.utils';

@Injectable({
  providedIn: 'root'
})
export class EfCakeTopologySharedService {
  constructor(private efateCakeTopologyApiService: EfateCakeTopologyApiService) {}

  async getCakeTopologyStateBySetupPk(efateSetupPk?: number): Promise<EfCakeTopologyUiState | undefined> {
    if (!efateSetupPk || efateSetupPk <= 0) {
      return undefined;
    }

    try {
      const topology = await firstValueFrom(this.efateCakeTopologyApiService.getEfateCakeTopologyBySetupPk(efateSetupPk).pipe(take(1)));
      const topologyJson = topology?.topologyJson ?? topology?.TopologyJson ?? topology;

      if (!topologyJson || typeof topologyJson !== 'string' || !topologyJson.trim()) {
        return undefined;
      }

      const parsed = JSON.parse(topologyJson) as Partial<EfCakeTopologyUiState>;
      return EfCakeTopologyStateUtils.buildUiState(parsed);
    } catch {
      return undefined;
    }
  }
}
